export default {
  "lang.label": "言語",
  "lang.zh-TW": "繁体字中国語",
  "lang.zh-CN": "簡体字中国語",
  "lang.en": "英語",
  "lang.ja": "日本語",
  "nav.home": "ホーム",
  "nav.about": "ブランド紹介",
  "nav.books": "書籍カタログ",
  "nav.stores": "取扱ストア",
  "nav.faq": "よくある質問",
  "nav.blog": "編集部おすすめ",
  "nav.contact": "お問い合わせ",
  "nav.partners": "パートナー",
  "nav.services": "サービス",
  "nav.app": "爽読アプリ",
  "nav.more": "その他",
};
